import React from "react";
import { ArrowLeft } from "lucide-react";

interface PrincipalFormHeaderProps {
  title: string;
  onBack: () => void;
}

const PrincipalFormHeader: React.FC<PrincipalFormHeaderProps> = ({ title, onBack }) => {
  return (
    <div className="flex border-b border-cardborder mb-8 flex-col md:flex-row md:items-center md:justify-between max-w-7xl mx-auto px-7 py-8">
      <div className="flex items-center gap-3">
        <button
          onClick={onBack}
          className="p-1.5 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Go back"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
        <h1 className="text-2xl font-bold text-gray-900">
          {title}
        </h1>
      </div>
    </div>
  );
};

export default PrincipalFormHeader;

